module.exports = __webpack_public_path__ + "img/apple-store-jp.81c4efb7.png";